import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import TcIndexPage from './TcIndexPage';
import { addNotification } from 'actions/notifications/notifications';

export const NotificationContext = React.createContext(undefined);

function TcIndex({ addNotification }) {
    return (
        <div className='table-page'>
            <div className='container'>
                <h2>Tc Hire Idea</h2>
                <NotificationContext.Provider value={addNotification}>
                    <TcIndexPage />
                </NotificationContext.Provider>
            </div>
        </div>
    );
}

export default connect(
    null,
    dispatch => bindActionCreators({
        addNotification
    }, dispatch),
)(TcIndex);



// WEBPACK FOOTER //
// ./app/components/TcIndex/TcIndex.jsx